export default function genererCritereRechercheMaterielTlpe() {
  return {
    auto: '',
    codes: [],
    formats: [],
    typesMateriels: [],
    typesDispositifs: [],
    supports: [],
    etats: [],
    adresse: null,
    villes: [],
    agglomerations: [],
    datesMontage: null,
    datesDemontage: null,
    agencesId: [],
    disposition: [],
    collectivite: [],
    typeTaxation: [],
    sansCollectivite: false,
    sansTypeTaxation: false,
    declarable: null,
    numerique: null,
    sansDateMontage: false,
    sansDateDemontage: false,
    confrere: null,
    collectiviteId: null,
    collectiviteIds: [],
    descriptionsTlpe: [],
    actif: true,
    etatsMontageTlpe: [],
    etatsDemontageTlpe: [],
    secteurs: [],
  };
}
